export default __webpack_public_path__ + "static/media/logo-m@2x.e2b68307.png";